import YandexGoals from 'www/modules/YandexGoals'

new YandexGoals({
  dataName: 'data-reviews-list-yandex-goals',
})
